<div leaflet class="h-100 notranslate" [leafletOptions]="options"
     (leafletMapZoomEnd)="emitVisibleLayers()"
     (leafletMapMoveEnd)="emitVisibleLayers()">
</div>